import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import LoginTop from '@/views/LoginTop.vue'
import LoginAuth from '@/views/users/LoginAuth.vue'
import DownloadMail from '@/views/users/DownloadMail.vue'
import EntryAuthSend from '@/views/users/EntryAuthSend.vue'
import EntryAuth from '@/views/users/EntryAuth.vue'
import EntryPassword from '@/views/users/EntryPassword.vue'
import PasswordUpdate from '@/views/users/settings/PasswordUpdate.vue'
import AgreeLicense from '@/views/users/AgreeLicense.vue'
import ResetPassword from '@/views/users/ResetPassword.vue'
import TheHelp from '@/views/TheHelp.vue'
import NotFound from '@/views/NotFound.vue'
import ROUTER_TYPE from './routeType'

// router情報
const routes: Array<RouteRecordRaw> = [
  // TOP画面
  {
    path: ROUTER_TYPE.TOP.path,
    name: ROUTER_TYPE.TOP.name,
    component: LoginTop,
    props: true,
  },
  // ユーザーTOP画面
  {
    path: ROUTER_TYPE.LOGIN_TOP.path,
    name: ROUTER_TYPE.LOGIN_TOP.name,
    component: LoginTop,
    props: true,
  },
  // パスワード認証画面
  {
    path: ROUTER_TYPE.LOGIN.path,
    name: ROUTER_TYPE.LOGIN.name,
    component: LoginAuth,
    props: true,
  },
  // ダウンロード初期画面
  {
    path: ROUTER_TYPE.DOWNLOAD.path,
    name: ROUTER_TYPE.DOWNLOAD.name,
    component: DownloadMail,
    props: true,
  },
  // ダウンロード詳細画面
  {
    path: ROUTER_TYPE.DOWNLOAD_DETAIL.path,
    name: ROUTER_TYPE.DOWNLOAD_DETAIL.name,
    component: DownloadMail,
    props: true,
  },
  // ワンタイムパスワード送信画面
  {
    path: ROUTER_TYPE.ENTRYAUTHSEND.path,
    name: ROUTER_TYPE.ENTRYAUTHSEND.name,
    component: EntryAuthSend,
    props: true,
  },
  // ワンタイムパスワード認証画面
  {
    path: ROUTER_TYPE.ENTRYAUTH.path,
    name: ROUTER_TYPE.ENTRYAUTH.name,
    component: EntryAuth,
    props: true,
  },
  // パスワード登録画面
  {
    path: ROUTER_TYPE.ENTRY.path,
    name: ROUTER_TYPE.ENTRY.name,
    component: EntryPassword,
    props: true,
  },
  // パスワード変更画面
  {
    path: ROUTER_TYPE.USER_EDIT_PASS.path,
    name: ROUTER_TYPE.USER_EDIT_PASS.name,
    component: PasswordUpdate,
    props: true,
  },
  // ライセンス契約書同意画面
  {
    path: ROUTER_TYPE.AGREE_LICENSE.path,
    name: ROUTER_TYPE.AGREE_LICENSE.name,
    component: AgreeLicense,
    props: true,
  },
  // パスワードリセット画面
  {
    path: ROUTER_TYPE.RESET_PASSWORD.path,
    name: ROUTER_TYPE.RESET_PASSWORD.name,
    component: ResetPassword,
    props: false,
  },
  // ヘルプ画面
  {
    path: ROUTER_TYPE.HELP.path,
    name: ROUTER_TYPE.HELP.name,
    component: TheHelp,
    props: false,
  },
  // 404画面(ページ未存在)
  // この設定は最後に置く事
  {
    path: ROUTER_TYPE.NOTFOUNT.path,
    name: ROUTER_TYPE.NOTFOUNT.name,
    component: NotFound,
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
export { routes }
